import { ENV_DEV } from "../window";

/**
 * Check for nested responsive definition. If found, throw a warning.
 * @param {String} input
 * @param {String} original
 * @returns {Boolean}
 */
const checkNestedResolutions = (input, original) => {
  if (/::|˸˸/.test(input)) {
    if (ENV_DEV) {
      console.warn(`[TorusKit warn]: Nested responsive definitions are not supported. Found in: \`${original}\``)
    }

    return true;
  } else {
    return false;
  }
}

export default checkNestedResolutions;